import { Button, Flex, Title } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { ReadOutlined } from "@/icons"

import styles from "./HowToUseTemplate.module.scss"

import type { HowToUseTemplateProps } from "./HowToUseTemplate.types"

export const HowToUseTemplate = (props: HowToUseTemplateProps) => {
  const { title, instructionsLink, aside, children, selfHosted } = props
  const { t } = useTranslation()

  return (
    <>
      <Flex
        className={styles.titleContainer}
        align="center"
        justify="space-between"
      >
        <Title level={5} className={styles.title}>
          {title}
        </Title>
        {!selfHosted && instructionsLink && (
          <Button
            icon={<ReadOutlined />}
            type="link"
            href={instructionsLink}
            target="_blank"
          >
            {t("general.readFullInstructions")}
          </Button>
        )}
      </Flex>
      {aside}
      <div className={styles.steps}>{children}</div>
    </>
  )
}
